export enum DemoPushType {
  SCENARIO_STARTED = 'SCENARIO_STARTED',
  SCENARIO_STOPPED = 'SCENARIO_STOPPED',
  USAGE_ENDED = 'USAGE_ENDED',
}
